// Spanish translations
const es = {
  // This is a placeholder. Copy translations from en.js and translate them to Spanish
  // For now, we'll include just the essential structure to prevent errors
  
  navigation: {
    tracking: "Seguimiento",
    search: "Buscar",
    login: "miMSC",
    language: "Idioma"
  },
  
  menu: {
    solutions: "Soluciones",
    industries: "Industrias",
    ebusiness: "eNegocio",
    sustainability: "Sostenibilidad",
    aboutUs: "Sobre Nosotros",
    schedules: "Horarios"
  },
  
  hero: {
    leaderIn: "LÍDER EN",
    shippingLogistics: "ENVÍOS Y LOGÍSTICA",
    trackingTab: "SEGUIMIENTO",
    schedulesTab: "HORARIOS",
    contactsTab: "CONTACTOS",
    containerBol: "Número de contenedor / conocimiento de embarque",
    bookingNumber: "Número de reserva",
    searchPlaceholder: "Buscar nuestros servicios y soluciones...",
    searchButton: "Buscar"
  },
  
  // Default fallback for other sections
  example: {},
  services: {},
  stats: {
    title: "Alcance Global, Experiencia Local",
    description: "Con una sólida red global y un profundo conocimiento local, conectamos empresas a través de los continentes.",
    years: "Años de Experiencia",
    countries: "Países Atendidos",
    clients: "Clientes Activos",
    shipments: "Envíos Anuales"
  },
  industries: {},
  footer: {}
};

export default es; 